import { formatPhone } from '../../../../../../../../../../../../common/functions/formatPhone';
import { BrokerAgreementBorrower } from '../../../../../../../queries/brokerAgreementQueries';

/** The agreement borrower's email and phone, then the user it signs in as. */
export const BorrowerContact = ({ borrower }: { borrower: BrokerAgreementBorrower }) => {
    return (
        <>
            {borrower.email && <div>{borrower.email}</div>}
            {borrower.phone && <div>{formatPhone(borrower.phone)}</div>}
            {borrower.userName && <div>User: {borrower.userName}</div>}
        </>
    );
};
